import { useSyncExternalStore } from 'react'

// Acknowledging the old informational notice did not authorize third-party analytics.
const STORAGE_KEY = 'lupa_analytics_consent_v1'
const CHANGE_EVENT = 'lupa:analytics-consent'
const OPEN_EVENT = 'lupa:cookie-settings'
export type AnalyticsConsent = 'granted' | 'denied' | null
let sessionChoice: AnalyticsConsent = null

export function getAnalyticsConsent(): AnalyticsConsent {
  if (sessionChoice !== null) return sessionChoice
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    if (value === 'granted' || value === 'denied') return value
  } catch {
    // Storage can be unavailable in private mode; the choice still works for this session.
  }
  return sessionChoice
}

export function setAnalyticsConsent(value: Exclude<AnalyticsConsent, null>) {
  sessionChoice = value
  try {
    localStorage.setItem(STORAGE_KEY, value)
    sessionChoice = null
  } catch { /* Keep the in-memory choice. */ }
  window.dispatchEvent(new Event(CHANGE_EVENT))
}

function subscribe(listener: () => void) {
  window.addEventListener(CHANGE_EVENT, listener)
  const onStorage = (event: StorageEvent) => {
    if (event.key !== null && event.key !== STORAGE_KEY) return
    sessionChoice = null
    listener()
  }
  window.addEventListener('storage', onStorage)
  return () => {
    window.removeEventListener(CHANGE_EVENT, listener)
    window.removeEventListener('storage', onStorage)
  }
}

export function useAnalyticsConsent() {
  return useSyncExternalStore(subscribe, getAnalyticsConsent, () => null)
}

export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_EVENT))
}

export function subscribeCookieSettings(listener: () => void) {
  window.addEventListener(OPEN_EVENT, listener)
  return () => window.removeEventListener(OPEN_EVENT, listener)
}
